module.exports = __webpack_public_path__ + "img/fabricacion.21202fec.jpg";